module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Black.5d60aba7.woff2";